import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const DeleteConfirmationModal = ({ isOpen, onClose, onConfirm, item, isDeleting }) => {
  if (!isOpen || !item) return null;

  return (
    <div className="fixed inset-0 bg-foreground/80 backdrop-blur-sm z-50 flex items-center justify-center p-4">
      <div className="bg-background rounded-lg w-full max-w-md elevation-3">
        <div className="p-6">
          <div className="w-12 h-12 bg-error/10 rounded-full flex items-center justify-center mb-4">
            <Icon name="AlertTriangle" size={24} color="var(--color-error)" />
          </div>

          <h2 className="text-xl font-semibold text-foreground mb-2">Delete Inventory Item</h2>
          <p className="text-sm text-muted-foreground mb-4">
            Are you sure you want to delete this item? This action cannot be undone.
          </p>

          <div className="bg-muted rounded-lg p-4 mb-6">
            <div className="flex items-start gap-3">
              <Icon name="Package" size={20} color="var(--color-muted-foreground)" />
              <div className="flex-1">
                <p className="text-sm font-semibold text-foreground mb-1">{item?.name}</p>
                <p className="text-xs text-muted-foreground font-mono">{item?.liin}</p>
              </div>
            </div>
          </div>

          <div className="flex gap-3">
            <Button
              variant="outline"
              onClick={onClose}
              disabled={isDeleting}
              className="flex-1"
            >
              Cancel
            </Button>
            <Button
              variant="destructive"
              onClick={onConfirm}
              loading={isDeleting}
              iconName="Trash2"
              iconPosition="left"
              iconSize={16}
              className="flex-1"
            >
              Delete Item
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DeleteConfirmationModal;